import api from './axiosInstance';
import base_url from './Config';

// Returns applicationId for a given customerId via /api/lead/applicationIdByCustomerId.
// Falls back to customerId string if not found (safe default for the entire flow).
const getApplicationId = async (customerId) => {
  try {
    const res = await api.get(`${base_url}/api/lead/applicationIdByCustomerId`, {
      params: { customerId },
    });
    return res.data?.applicationId || String(customerId);
  } catch {
    return String(customerId);
  }
};

export default getApplicationId;
